import classNames from "classnames";
import { CourseCardSkeleton } from "./course-card";
import PackListSkeleton from "./card-list";
import InstructorListSkeleton from "./instructor-list";

const PackSkeleton = () => {
  return (
    <div className="pb-20 ">
      <div className=" w-full  whitespace-nowrap flex-nowrap  ">
        <nav className="h-12 bg-white">
          <div className="px-5 w-full max-w-[1920px] flex justify-between items-center h-full ">
            <ul className="flex  justify-start animate-pulse">
              <li className="w-20 h-2 bg-[#e6e6e6] rounded-full m-1.5"></li>
              <li className="mx-2 text-[#6c757d]">/</li>
              <li className="w-20 h-2 bg-[#e6e6e6] rounded-full m-1.5"></li>
              <li className="mx-2 text-[#6c757d]">/</li>
              <li className="w-20 h-2 bg-[#e6e6e6] rounded-full m-1.5"></li>
            </ul>
          </div>
        </nav>
        <div className="md:px-6 px-4 max-w-[1280px] mx-auto mt-1 e">
          <div className="flex lg:flex-row flex-col lg:h-[280px] mb-6 ">
            <div className="w-full h-[56vw]   lg:h-full shrink-0  grow-0  lg:min-w-[499px] lg:max-w-[499px] bg-gray-50 animate-puls rounded-lg" />
            <div className="lg:mr-6 lg:pt-0  flex flex-col justify-between grow lg:mt-0 mt-10 ">
              <div>
                <div className="w-1/2 bg-gray-50 animate-pulse h-7 mb-2" />
                <div className="w-full bg-gray-50 animate-pulse h-5 mt-0.5 " />
                <div className="w-full bg-gray-50 animate-pulse h-5 mt-0.5 " />
                <div className="w-1/2 bg-gray-50 animate-pulse h-5 mt-0.5" />
              </div>
              <div className="flex md:flex-row flex-col-reverse gap-y-4 md:gap-y-0 gap-x-8 mt-6 ">
                {Array(3)
                  .fill("")
                  .map((_, idx) => (
                    <div key={idx} className="flex gap-x-2 items-center">
                      <div className="bg-gray-50 rounded-lg animate-pulse h-12 w-12 ml-2 " />
                      <div className="w-[100px] bg-gray-50 animate-pulse h-5 mt-0.5 rounded-md" />
                    </div>
                  ))}
              </div>
              <div
                className="flex md:gap-x-6  px-2.5 md:px-0 justify-between md:relative fixed bg-white md:shadow-none md:py-0 md:items-end items-center  py-[14px] shadow-[0px_-1px_2px_0px_#00000014]
 overflow-hidden bottom-0 inset-x-0 md:z-[unset] z-[50] md:border-t-0 border-t-[#F4F4F5] border-t"
              >
                <div className="bg-gray-50 h-12 w-[186px] rounded-md animate-pulse" />
                <div className="">
                  <div className="bg-gray-50 h-5 lg:w-[160px] w-20 rounded-md animate-pulse" />
                  <div className="bg-gray-50 h-5 mt-1 lg:w-[160px] w-10 rounded-md animate-pulse" />
                </div>
              </div>
            </div>
          </div>
          <div className="bg-zinc-50 border border-zinc-200 p-6 rounded-lg ">
            <div className="bg-zinc-100 h-6 w-24 mb-2  animate-pulse" />
            <div className="bg-zinc-100 h-5 w-full mb-2  animate-pulse" />
            <div className="bg-zinc-100 h-5 w-full mb-2  animate-pulse" />

            <div className="bg-zinc-100 h-6 w-24 mb-2 mt-4  animate-pulse" />
            <div className="bg-zinc-100 h-5 w-full mb-2  animate-pulse" />
            <div className="bg-zinc-100 h-5 w-full mb-2  animate-pulse" />

            <div className="bg-zinc-100 h-6 w-24 mb-2 mt-4  animate-pulse" />
            <div className="bg-zinc-100 h-5 w-full mb-2  animate-pulse" />
          </div>
          <div className=" gap-x-11 gap-y-10 py-6 justify-center flex-wrap md:flex hidden">
            {Array(4)
              .fill("")
              .map((_, idx) => (
                <div
                  key={idx}
                  className="w-[275px] rounded-xl  flex items-center  h-20 bg-gray-50 animate-pulse  shadow-[0_2px_6px_0px_rgba(0,0,0,0.25)]"
                />
              ))}
          </div>
          <div className=" bg-white pt-1.5 gap-x-[5px] lg:my-10  md:my-7 my-6 flex border-b border-b-zinc-200">
            {Array(3)
              .fill("")
              .map((_, idx) => (
                <div
                  key={idx}
                  className={classNames(
                    "p-3 flex justify-center items-center w-20",
                    {
                      "border-b-2  border-b-blue-950": idx === 0,
                    }
                  )}
                >
                  <div className="w-3/4 h-3 bg-gray-50 animate-pulse rounded" />
                </div>
              ))}
          </div>
          <div className="h-6 w-[200px] bg-gray-50 animate-pulse rounded " />
          <div className="h-5 mt-2 w-1/2 bg-gray-50 animate-pulse rounded " />
          <div className="mt-12">
            {Array(3)
              .fill("")
              .map((_, idx) => (
                <div key={idx} className="flex gap-x-4 mb-6">
                  <div className="sm:flex items-center flex-col w-12 hidden  ">
                    <div className="rounded-full bg-[#A5CFF5] flex items-center justify-center border-2 outline-offset-2 border-white outline-[#A5CFF5] outline outline-2  w-9 h-9"></div>

                    <div className="w-0.5 h-full max-h-[150px] mt-2 bg-[#A5CFF5] " />
                  </div>
                  <div className="w-full grow shrink ">
                    <CourseCardSkeleton />
                  </div>
                </div>
              ))}
          </div>
          <div className=" mb-12">
            <InstructorListSkeleton />
          </div>
          <div className=" mb-12">
            <PackListSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
};
export default PackSkeleton;
